{
 "source": "src/audio/sfx/extraPresets.ts: the remake's own effect blocks, run through the C64 driver like the six",
 "note": "Generated by tools/capture-sfx.mjs - do not edit. Per effect: base64 of packed frames (per 50 Hz frame a write count, then register/value pairs to voice 1, $D400-$D406, in the order the driver made them; frame 0 is sfx_start's, the last silences the voice).",
 "frameHz": 50,
 "effects": [
  {
   "name": "blow",
   "block": "$400",
   "bytes": "00 05 80 fd 00 00 00 00 03 04 00 00 00 04 00 00 00 00 00 00 00 00 00 00 19 07 f6 01 08 3e",
   "table": "",
   "frames": 10,
   "data": "FQYIBgAFCAUABAgEAAMIAwACCAIAAQgBAAAIAAAG9gUHBBkDAAIAADUBJwMEEAA1ASwCADUBMQIANQE2AgC1ATMCADUBMQIAtQEuAgA1ASwCADUBLAcGAAUABAADAAIAAQAAAA=="
  },
  {
   "name": "pop",
   "block": "$440",
   "bytes": "00 f7 00 00 00 00 00 00 04 00 00 00 00 04 00 00 00 00 00 00 00 00 00 00 19 07 f4 01 05 54",
   "table": "",
   "frames": 7,
   "data": "FQYIBgAFCAUABAgEAAMIAwACCAIAAQgBAAAIAAAG9AUHBBkDAAIAALoBiwMEEAC6AYICALoBeQIAugFwAgC6AWcCALoBZwcGAAUABAADAAIAAQAAAA=="
  },
  {
   "name": "chain",
   "block": "$480",
   "bytes": "00 00 00 00 02 00 02 00 a0 04 3c 03 03 0d 00 00 00 00 00 00 00 00 00 08 49 07 f8 01 10 3c",
   "table": "10 0c 07 04",
   "frames": 18,
   "data": "FQYIBgAFCAUABAgEAAMIAwACCAIAAQgBAAAIAAAG+AUHBEkDCAIAAO0BIgEEQAIAAQEsAAIAVwE0AAIA3gFFAAIABgFYAAIAAQEsAAIAVwE0AAIA3gFFAAIABgFYBwYABQAEAAMAAgABAAAA"
  },
  {
   "name": "trap",
   "block": "$4C0",
   "bytes": "40 02 80 fe 00 03 00 00 03 03 06 00 00 04 06 00 00 84 80 00 00 00 00 02 49 07 f7 01 0e 30",
   "table": "",
   "frames": 16,
   "data": "FQYIBgAFCAUABAgEAAMIAwACCAIAAQgBAAAIAAAG9wUHBEkDAgIAAHkBEQUEQAKAAwQAuQETBAIAAwUA+QEVBAKAAwUAOQEYBAIAAwYAuQEWBAKAAwYAOQEVBAIAAwcAuQETBAKAAwIAuQEWBAIAAwMAuQEZBAKAAwMAuQEcBAIAAwQAuQEfBAKAAwQAuQEiBAIAAwUAuQElBAKAAwIAuQElBAIAAwMAuQElBwYABQAEAAMAAgABAAAA"
  },
  {
   "name": "death",
   "block": "$500",
   "bytes": "80 fd c0 00 00 00 00 00 02 02 00 00 00 05 08 08 00 05 40 00 c0 ff 00 04 49 07 fb 01 3c 4c",
   "table": "",
   "frames": 62,
   "data": "FQYIBgAFCAUABAgEAAMIAwACCAIAAQgBAAAIAAAG+wUHBEkDBAIAAAYBWAUEQAJAAwQAhgFVBAKAAwQABgFTBALAAwQAxgFTBAIAAwUAhgFUBAJAAwUABgFSBAKAAwUAhgFPBALAAwUARgFQBAIAAwYABgFRBALAAwUAhgFOBAKAAwUABgFMBAJAAwUAxgFMBAIAAwUAhgFNBALAAwQABgFLBAKAAwQAhgFIBAJAAwQARgFJBAIAAwQABgFKBAJAAwQAhgFHBAKAAwQABgFFBALAAwQAxgFFBAIAAwUAhgFGBAJAAwUABgFEBAKAAwUAhgFBBALAAwUARgFCBAIAAwYABgFDBALAAwUAhgFABAKAAwUABgE+BAJAAwUAxgE+BAIAAwUAhgE/BALAAwQABgE9BAKAAwQAhgE6BAJAAwQARgE7BAIAAwQABgE8BAJAAwQAhgE5BAKAAwQABgE3BALAAwQAxgE3BAIAAwUAhgE4BAJAAwUABgE2BAKAAwUAhgEzBALAAwUARgE0BAIAAwYABgE1BALAAwUAhgEyBAKAAwUABgEwBAJAAwUAxgEwBAIAAwUAhgExBALAAwQABgEvBAKAAwQAhgEsBAJAAwQARgEtBAIAAwQABgEuBAJAAwQAhgErBAKAAwQABgEpBALAAwQAxgEpBAIAAwUAhgEqBAJAAwUABgEoBAKAAwUAhgElBALAAwUARgEmBAIAAwYABgEnBALAAwUAhgEkBAKAAwUABgEiBAJAAwUAxgEiBAIAAwUAhgEjBwYABQAEAAMAAgABAAAA"
  },
  {
   "name": "levelClear",
   "block": "$540",
   "bytes": "00 00 00 00 03 00 03 00 60 05 3c 0c 0c 0d 00 00 00 00 00 00 00 00 00 08 49 07 fa 01 26 3c",
   "table": "18 18 18 18 18 18 18 18 13 10 0c 07 04",
   "frames": 40,
   "data": "FQYIBgAFCAUABAgEAAMIAwACCAIAAQgBAAAIAAAG+gUHBEkDCAIAAO0BIgEEQAACAAEBLAAAAgBXATQAAAIA3gFFAAACAAYBWAAAAgCtAWgAAAIAugGLAAACALoBiwAAAgC6AYsAAAIAugGLAAACALoBiwAAAgC6AYsAAAIAugGLAAAHBgAFAAQAAwACAAEAAAA="
  },
  {
   "name": "hurryUp",
   "block": "$580",
   "bytes": "00 04 00 fd 00 00 00 00 0a 0e 00 00 00 04 00 00 00 00 00 00 00 00 00 00 89 07 f9 01 1c 30",
   "table": "",
   "frames": 30,
   "data": "FQYIBgAFCAUABAgEAAMIAwACCAIAAQgBAAAIAAAG+QUHBIkDAAIAAHkBEQMEgAB5ARUCAHkBGQIAeQEdAgB5ASECAHkBJQIAeQEpAgB5AS0CAHkBMQIAeQE1AgB5ATkCAHkBNgIAeQEzAgB5ATACAHkBLQIAeQEqAgB5AScCAHkBJAIAeQEhAgB5AR4CAHkBGwIAeQEYAgB5ARUCAHkBEgIAeQEPAgB5AQ8CAHkBDwIAeQEPAgB5AQ8HBgAFAAQAAwACAAEAAAA="
  }
 ]
}
